import React, { useEffect, useState } from 'react'
import { AwsUpdate } from '../../../../utils/tool'

export default function FileUploader(props) {
    const [uploading, setUploading] = useState(false)
    const [uploadPercent, setUploadPercent] = useState(0)
    const [uploadImg, setUploadImg] = useState('')

    useEffect(() => {
        setUploadImg(props.url || '')
    }, [props.url])

    const handleFileInput = (e) => {
        const file = e.target.files?.[0]
        if (!file) return

        if (props.onBeforeUpload) {
            if (!props.onBeforeUpload(file)) {
                e.target.value = ''
                return
            }
        }

        const key = `${Date.now()}-${file.name}`
        e.target.value = ''
        setUploadImg('')
        setUploadPercent(0)
        setUploading(true)
        props.onUploadingChange?.(true)

        AwsUpdate(file, key, (progress) => {
            const percent = progress.total > 0
                ? Math.round((progress.loaded / progress.total) * 10000) / 100
                : 0
            setUploadPercent(percent)
        }).then((result) => {
            setUploadImg(result.Location)
            setUploading(false)
            props.onUploadingChange?.(false)
            props.onFileUpload?.(result.Location)
        }).catch((error) => {
            setUploadImg(props.url || '')
            setUploading(false)
            props.onUploadingChange?.(false)
            props.onUploadError?.(error)
        })
        props.onFileSelect?.(file)
    }

    return (<>
        <div style={{ 'width': props.width, 'minHeight': props.height }} className="stake-file-uploader">
            <input
                type="file" accept="image/*" onChange={handleFileInput} />
            {!uploadImg && <div className="stake-file-uploader-box">
                {uploading && <div className="stake-file-uploader-box-loading">
                    <div>
                        <i style={{ 'fontSize': '20px' }} className="fa fa-spinner loading-css"></i>
                    </div>
                    <div>
                        {uploadPercent}%
                    </div>

                </div>}

                {!uploading && '+'}
            </div>}
            {uploadImg && <div className="stake-file-uploader-box">
                <img src={uploadImg} className="stake-file-uploader-box-img" alt={props.alt || ''} />
            </div>}
        </div>
    </>)
}
